import { img, thumbImg } from "@/lib/images";

const h = (num: string, caption: string, captionEn: string) => ({
  key: `villas/villa-hibiscus/villa-hibiscus-view-${num}.jpg`,
  thumb: thumbImg(`villas/villa-hibiscus/villa-hibiscus-view-${num}.jpg`),
  full: img(`villas/villa-hibiscus/villa-hibiscus-view-${num}.jpg`),
  caption,
  captionEn,
});

// Standard-Beschriftungen – 1:1 identisch mit den im Backstage
// gepflegten Werten (Tabelle gallery_captions, DE + EN).
export const hibiskusGalleryImages = [
  h("01", "Villa Hibiskus - Eingangshalle", "Villa Hibiscus - Hall"),
  h("02", "Villa Hibiskus - Eingangshalle", "Villa Hibiscus - Hall"),
  h("03", "Villa Hibiskus - Küche", "Villa Hibiscus - Kitchen"),
  h("04", "Villa Hibiskus - Schlafzimmer 1", "Villa Hibiscus - Bedroom 1"),
  h("05", "Villa Hibiskus - Schlafzimmer 2", "Villa Hibiscus - Bedroom 2"),
  h("06", "Villa Hibiskus - Schlafzimmer 3", "Villa Hibiscus - Bedroom 3"),
  h("07", "Villa Hibiskus - Essterrasse", "Villa Hibiscus - Dining terrace"),
  h("08", "Villa Hibiskus - Haupteingang", "Villa Hibiscus - Main Entrance"),
  h("09", "Villa Hibiskus - Pool", "Villa Hibiscus - Pool"),
];